// extracted by mini-css-extract-plugin
export var avatarContainer = "_dn-0";
export var avatarTypingWave = "_dn-i";
export var gray = "_dn-f";
export var green = "_dn-c";
export var icon = "_dn-9";
export var image = "_dn-1";
export var lg = "_dn-6";
export var md = "_dn-5";
export var presenceDot = "_dn-b";
export var red = "_dn-d";
export var sm = "_dn-4";
export var status = "_dn-a";
export var typingDot = "_dn-h";
export var typingPill = "_dn-g";
export var xl = "_dn-7";
export var xs = "_dn-3";
export var xxl = "_dn-8";
export var xxs = "_dn-2";
export var yellow = "_dn-e";